export default __webpack_public_path__ + "static/texture-orange-3c942a966290d92ed216d3866e56ebbb.png";